export default "__VITE_ASSET__BeoJ7DZ___"